(function () {
  var blogNavS = document.querySelector('.blog-nav-s');
  var blogNav = document.querySelector('.blog-nav');
  var blogNavBg = document.querySelector('.blog-nav-bg');
  var blogNavBut = document.querySelector('.blog-nav-svg');
  var blogNavList = document.querySelector('.blog-nav-list');
  var blogNavActiveText = document.querySelector('.blog-nav-active-text');
  var blogNavLi = document.querySelectorAll('.blog-nav-list li');
  var blogNavContent = document.querySelectorAll('.blog-nav-content > .tags-content');
  var blogMoreClick = document.querySelector('.blog-more');
  var blogMoreBox = document.querySelector('.blog-more-box');
  var blogMoreData = document.querySelectorAll('.blog-more-data');
  var dataCount = blogMoreData.length;
  var dataMoreIndex = 0;
  var dataMoreClick = 9;

  var newsletter = document.querySelector('.blog-newsletter');
  if (newsletter) {
    var emailInput = newsletter.querySelector('input[type="email"]');
    var submitButton = newsletter.querySelector('input[type="submit"]');
    if (emailInput && newsletter.dataset.placeholder) emailInput.placeholder = newsletter.dataset.placeholder;
    if (submitButton && newsletter.dataset.submit) submitButton.value = newsletter.dataset.submit;
  }

  function preventDefaultScroll(event) {
    event.preventDefault();
  }

  function openOverlay() {
    blogNavBg.style.display = 'block';
    document.body.style.overflow = 'hidden';
    document.addEventListener('touchmove', preventDefaultScroll, { passive: false });
  }

  function closeOverlay() {
    blogNavBg.style.display = 'none';
    document.body.style.overflow = 'auto';
    document.removeEventListener('touchmove', preventDefaultScroll);
  }

  blogNavBut.addEventListener('click', function () {
    if (blogNavBut.classList.contains('active')) {
      blogNavS.classList.remove('active');
      blogNavBut.classList.remove('active');
      blogNavList.classList.remove('active');
      closeOverlay();
    } else {
      blogNavS.classList.add('active');
      blogNavBut.classList.add('active');
      blogNavList.classList.add('active');
      openOverlay();
    }
  });

  if (window.innerWidth < 1200) {
    blogNavBg.addEventListener('click', function () {
      if (blogNavBut.classList.contains('active')) {
        blogNavS.classList.remove('active');
        blogNavBut.classList.remove('active');
        closeOverlay();
      } else {
        blogNavBut.classList.add('active');
        openOverlay();
      }
    });
  }

  function showData() {
    for (var i = dataMoreIndex; i < dataMoreIndex + dataMoreClick && i < dataCount; i++) {
      blogMoreData[i].style.display = 'block';
    }
  }

  blogMoreClick.addEventListener('click', function () {
    dataMoreIndex += dataMoreClick;
    if ((dataMoreIndex + dataMoreClick) >= dataCount || dataMoreIndex >= dataCount) {
      blogMoreBox.style.display = 'none';
    }
    showData();
  });
  showData();

  blogNavLi.forEach(function (item, index) {
    item.addEventListener('click', function () {
      blogNav.style.background = index > 0 ? '#f1f1f1' : '#fff';
      blogNavLi.forEach(function (li) { li.classList.remove('active'); });
      blogNavContent.forEach(function (content) { content.classList.remove('active'); });
      blogNavS.classList.remove('active');
      blogNavContent[index].classList.add('active');
      blogNavActiveText.innerHTML = item.innerHTML;
      item.classList.add('active');
      window.scrollTo(0, 0);
    });
  });

  var siteHeader = document.querySelector('.site-header');
  var fixedState = null;
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var fixed = fixedState;
    if (y < 1) fixed = false;
    else if (y >= 20) fixed = true;
    if (fixed === fixedState) return;
    fixedState = fixed;
    blogNav.classList.toggle('blog-nav-fixed', fixed);
    if (siteHeader) siteHeader.style.opacity = fixed ? '0' : '1';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
